// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SignInIcon_wrapper__2Lpua","text":"SignInIcon_text__3dcNc","circle":"SignInIcon_circle__3fozi","svgIcon":"SignInIcon_svgIcon__2oxLq"};